"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var config = {
  appUrl: process.env.REACT_APP_URL,
  google: process.env.REACT_APP_GOOGLE,
  sentry: process.env.REACT_APP_SENTRY,
  facebook: process.env.REACT_APP_FACEBOOK,
  stripe: process.env.REACT_APP_STRIPE_KEY,
  ASSETS_URL: process.env.REACT_APP_ASSET_URL,
  ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  facebookPageId: process.env.REACT_APP_FACEBOOK_ID,
  googleAnalytics: process.env.REACT_APP_GOOGLE_ANALYTICS,
  RESOURCE_URL: "".concat(process.env.REACT_APP_API_ENDPOINT, "/static"),
  honeyguidePhoneNumber: '+977-9803759639',
  honeyguideEmail: 'busybee@honeyguideapps.com',
  summitPhoneNumbers: ['977-1-4117524', '977-1-4117523', '977-1-5199097'],
  summitEmail: 'info@summitair.com.np'
};
var _default = config;
exports["default"] = _default;